// Selection eligibility only. Keep complete directories for historical names and saved assignments.
export function isSelectableUser(user) {
  return !!user && user.status?.accountStatus !== 'suspended'
}

export function isSelectableOrganization(org) {
  return !!org && org.status?.active !== false
}

export function isSelectableProjectType(type, { includeInactive = false } = {}) {
  return (
    !!type &&
    (includeInactive || type.isActive !== false) &&
    type.isVisible !== false &&
    type.legacy !== true &&
    !type.isDeleted
  )
}

export function isSelectableFinancialProduct(product) {
  return isSelectableProjectType(product) && product.isActive === true
}

export function selectorExclusion(collection, record) {
  if (['users', 'publicUsers'].includes(collection) && !isSelectableUser(record)) return 'suspended'
  if (collection === 'organizations' && !isSelectableOrganization(record)) return 'suspended'
  if (
    ['workflowProjectTypes', 'financialProducts'].includes(collection) &&
    !isSelectableProjectType(record)
  )
    return 'retiredProjectType'
  return null
}
